import { render, staticRenderFns } from "./create_new_btn.vue?vue&type=template&id=e04acdda&"
import script from "./create_new_btn.vue?vue&type=script&lang=js&"
export * from "./create_new_btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports